import { IPageContent } from "api/interfaces/static-content.type";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import PartNumber from "component/product/PartNumber";
import Price from "modules/components/prices/price/Price";
import PriceRange from "modules/components/prices/range-price/PriceRange";
import dynamic from "next/dynamic";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { getThumbImage } from "util/helper/getThumbImage";
import { getProductHeading } from "util/product/get-product-heading";
import { getThumbnailSrcV2 } from "util/product/getThumbmailSrc";
import styles from "./styles.module.scss";
const AddtoCartButton = dynamic(() => import(/* webpackChunkName: "add-to-cart-button" */"component/design-system/buttons/AddtoCartButton"));

interface IProps {
  staticContent: IPageContent;
}

function OverviewHeaderProduct(props: IProps) {
  const {
    hideMobileHeader, getThumbImagePath = getThumbImage, thumbnail, description, product,
    price, maximumPrice, minimumPrice, showAddtoCart, staticContent,
  } = props;

  const { pageDetails = {} } = staticContent;
  const {
    pickUpAvailable, shippingAvailable, thumbnailV2, thumbnail: productThumbnail,
  } = product || {};
  const h1 = getProductHeading(product, pageDetails);

  return (
    <div className={styles.mobileheader} hidden={hideMobileHeader}>
      <div
        className={`header_content col-sm-12 col-xs-12 m-b-10 ${styles.overview_header_content}`}
      >

        <div className={`${styles.overview_header_image}`}>

          <PAImage
            src={(thumbnailV2 || productThumbnail) ? getThumbnailSrcV2(product) : getThumbImagePath(thumbnail || "")} // getThumbImagePath for linePage
            width={80}
            height={80}
            alt={description}
          />
        </div>

        <div className={styles.overview_header_text}>
          <div className={styles.overview_header_subheader}>
            <PAImage
              src={getRelativeImagePath(product.manufacturerSmallImageUrl)}
              width={77}
              height={23}
              // alt={productAltText}
              // title={productAltText}
            />
            <PartNumber product={product} />
          </div>

          <div style={{ textAlign: "left" }}>
            <PAText component="h4" fontSize={FONT_SIZE[0]} color="black" bold>{h1}</PAText>
            {
              price && <Price {...{ price }} sameSize size="small" />
            }
            {
              maximumPrice && <PriceRange {...{ maximumPrice, minimumPrice }} />
            }
          </div>
        </div>
      </div>
      <HideIf show={showAddtoCart}>
        <AddtoCartButton
          {...{
            pickUpAvailable,
            shippingAvailable,
          }}
          product={product}
        />
      </HideIf>

    </div>
  );
}

export default OverviewHeaderProduct;
